import { render, staticRenderFns } from "./Index-OrderService.vue?vue&type=template&id=5107664b&scoped=true&"
import script from "./Index-OrderService.vue?vue&type=script&lang=js&"
export * from "./Index-OrderService.vue?vue&type=script&lang=js&"
import style0 from "./Index-OrderService.vue?vue&type=style&index=0&id=5107664b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5107664b",
  null
  
)

export default component.exports